<template>
  <div class="a-booking">
    <template v-if="user">
      <div class="content--main">
        <p class="m-0 booking-heading">
          Make a booking for
          <span :style="{ color: primary }">
            {{ user.firstName }} {{ user.lastName }}
          </span>
        </p>
        <Booking :user="user" />
      </div>
    </template>
    <div v-else>
      <p>User is not yet registered in our database.</p>
    </div>
  </div>
</template>

<script>
import Booking from "@/components/booking/Booking";
import axios from "@/helpers/axios";

export default {
  components: {
    Booking
  },
  data() {
    return {
      user: null
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  methods: {
    init() {
      axios.get("/users/" + this.id).then(response => {
        this.user = response.data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.a-booking {
  padding: 0 15px;
  .content--main {
    height: calc(100vh - 181px);
    overflow-x: hidden;
    overflow-y: auto;
    .booking-heading {
      font-size: $font-size-sm;
    }
  }
}
</style>
